<a href="/">
    <default-logo></default-logo>
</a>
